module.exports = __webpack_public_path__ + "img/37ae3b7332949d2b29d404ebdbc2ff39.png";